import $ from 'jquery';
import { applyAddressAutocompleteEventListeners } from './autocomplete/index.js';
import * as cookies from './cookies.js';

/**
 * Applies input type of 'date' to Gravity Forms date inputs.
 */
const applyDateTypeToDatepickers = () => {
  document
    .querySelectorAll('.gform_wrapper input.datepicker')
    .forEach((element) => element.setAttribute('type', 'date'));
};

/**
 * Applies input masking to telephone fields.
 */
const applyInputMaskingToTelephoneFields = () => {
  $('input[type="tel"][data-mask="standard"]')
    .on('keydown.mask', function (e) {
      const el = $(this)[0];

      /**
       * #todo
       * What if selectionStart isn't defined?
       * What if it is a number?
       */
      if (
        `selectionStart` in el &&
        typeof el.selectionStart === `number` &&
        el.selectionStart > 3
      ) {
        return;
      }

      // 49 is the keycode for 1
      // 97 is the keycode for numpad 1
      if (e.which === 49 || e.which === 97) {
        e.preventDefault();
      }

      // 48 is the keycode for 0
      // 96 is the keycode for numpad 0
      if (e.which === 48 || e.which === 96) {
        e.preventDefault();
      }
    })
    .on('input.mask keypress.mask', function () {
      const number = `${$(this).val()}`.replace(/\D/g, '');
      const sanitized = number.replace(/^[10]*/, '');

      if (`1${sanitized}` === number) {
        return;
      }

      $(this).val(sanitized).trigger('input.mask');
    });
};

/**
 * Applies a change event to select fields with the class 'autosubmit'.
 * This event submits the form when the select field's value changes.
 */
const applyChangeEventToAutoSubmitSelectFields = () => {
  $('.autosubmit select').one('change', function () {
    $(this).parents('form').addClass('disabled');
    $(this).parents('form').submit();
  });
};

/**
 * Applies custom markup for Gravity Forms multi-upload file list items.
 *
 * @description
 * Needs to be mirrored to `gform_file_upload_markup` in extras.php
 */
const applyMultiUploadMarkup = () => {
  window.gform?.addFilter?.(
    'gform_file_upload_markup',
    function (html, file, up) {
      if (!up?.settings?.multipart_params) return html;

      const { form_id: formId, field_id: fieldId } =
        up.settings.multipart_params;

      return (
        '<strong>' +
        file.name +
        "</strong> <img class='gform_delete' " +
        'src=\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"/></svg>\'' +
        "style='height: 1rem; cursor: pointer;' onclick='gformDeleteUploadedFile(" +
        formId +
        ',' +
        fieldId +
        ", this);' " +
        "alt='Delete'>"
      );
    }
  );
};

/**
 * Applies placeholder text to inline hero layout forms.
 */
const applyInlineHeroTextPlaceholders = () => {
  $('.hero-layout-inline .gform_fields :text').attr('placeholder', function () {
    const id = $(this).attr('id');
    const placeholder = $(this).attr('placeholder');
    const label = $(this)
      .parents('form')
      .find('label[for=' + id + ']');

    if (id && !placeholder && label.length == 1) {
      $(this).attr('placeholder', $(label).text());
    }
  });
};

const relocateConsentBoxesOnInlineHeroForms = () => {
  // Check if hero-layout-inline exists on the page
  if ($('.hero-layout-inline').length) {
    $('.hero-layout-inline .consentCheckbox').each(function () {
      // Wrap checkbox in consentWrapper div
      $(this).wrap('<div class="consentWrapper"></div>');

      // Find the closest form footer and move the wrapped checkbox after it
      const formFooter = $(this).closest('form').find('.gform_footer');
      if (formFooter.length) {
        $(this).parent('.consentWrapper').insertAfter(formFooter);
      }
    });
  }
};

/**
 * Processes form cookies and handles related telemtry.
 */
const processFormCookies = () => {
  const submissions = Object.entries(cookies.getSubmissions()).reduce(
    (submissions, [key, value]) => {
      if (value.eventposted === 0) {
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'oc_lead_form',
            formSubmitId: value.id,
            formSubmitPage: value.page,
            formSubmitTitle: value.title,
            formSubmitNumOfFields: value.numOfFields,
            formSubmitLocation: value.formlocation,
            formSubmitSiteId: value.siteid,
          });
        }

        if (typeof gtag === 'function')
          gtag('event', 'oc_lead_form', {
            formSubmitId: value.id,
            formSubmitPage: value.page,
            formSubmitTitle: value.title,
            formSubmitNumOfFields: value.numOfFields,
            formSubmitLocation: value.formlocation,
          });
      }

      return { ...submissions, [key]: { ...value, eventposted: 1 } };
    },
    {}
  );

  cookies.setSubmissions(submissions);

  document
    .querySelectorAll(
      'body.page .main .gform_wrapper, body.single-post .entry-content .gform_wrapper, body.single-lead .gform_wrapper'
    )
    .forEach((element) => {
      if (
        element.querySelectorAll('input[name="gform_return_access"]').length ===
        0
      )
        return;

      const submissions = cookies.getSubmissions();

      if (submissions) {
        const form = element.getElementsByTagName('form')[0];
        const elementId = form?.getAttribute('id');
        // @ts-expect-error -- #todo type safely
        const instanceId = parseInt(elementId.replace('gform_', ''));

        // TODO: better understand these values and parseInt() to restore a "===" check
        if (submissions[instanceId]?.id == instanceId) {
          window.location.href = submissions[instanceId].returnurl;
        }
      }
    });
};

export {
  applyAddressAutocompleteEventListeners,
  applyChangeEventToAutoSubmitSelectFields,
  applyDateTypeToDatepickers,
  applyInlineHeroTextPlaceholders,
  applyInputMaskingToTelephoneFields,
  applyMultiUploadMarkup,
  processFormCookies,
  relocateConsentBoxesOnInlineHeroForms,
};
